import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import Swal from 'sweetalert2';
import { FormLabel } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import request from '../../services/Request';
import '../user/form.css';
import { Modal } from 'react-bootstrap';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const updateAdress = '/machines/updateAdress';

export default function AddressModal(props) {
  const {
    reset,
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({});
  const classes = useStyles();
  const { data, user, setRowData, setMachines, ...rest } = props;

  const [loading, setLoading] = useState(true);

  const defaultValues = {
    location: data[0].address?.location ? data[0].address?.location : '',
    street: data[0].address?.street ? data[0].address?.street : '',
    city: data[0].address?.city ? data[0].address?.city : '',
    province: data[0].address?.province ? data[0].address?.province : '',
    postal_code: data[0].address?.postal_code ? data[0].address?.postal_code : '',
    country: data[0].address?.country ? data[0].address?.country : '',
    phone: data[0].address?.phone ? data[0].address?.phone : '',
    full_address: data[0].address?.full_address ? data[0].address?.full_address : '',
  };

  useEffect(async () => {
    if (props.show) {
      reset(defaultValues);
    }
  }, [props.show]);

  const onSubmit = async (formData) => {
    setLoading(false);
    const address = {
      location: formData.location,
      street: formData.street,
      city: formData.city,
      province: formData.province,
      postal_code: formData.postal_code,
      country: formData.country,
      phone: formData.phone,
      full_address: formData.full_address,
    };
    const machineID = data.map((e) => e._id);

    await request({
      method: 'post',
      url: updateAdress,
      data: {
        machineID: machineID,
        address: address,
      },
    })
      .then((res) => {
        setLoading(true);

        setMachines((prevMachines) =>
          prevMachines.map((e) => (machineID.includes(e._id) ? { ...e, address: address } : e))
        );
        setRowData((prevRowData) =>
          prevRowData.map((e) => ({
            ...e,
            address: address,
          }))
        );

        Swal.fire({
          text: `Your changes has been updated!`,
          icon: 'success',
        }).then(() => {
          // window.location.reload();
          props.onHide();
        });
      })
      .catch((error) => {
        setLoading(true);
        Swal.fire({
          text: error?.response?.data?.message || 'Failed to update address',
          icon: 'Error',
        });
      });
  };

  return (
    <Modal className="modal-w" {...rest} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" style={{ fontSize: '1.2rem' }}>
          Update Settings
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)} noValidate>
              <Grid container spacing={2}>
                <Grid item xs={12} style={{ textAlignLast: 'center' }}>
                  <FormLabel component="legend">Address</FormLabel>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    label="Full Address (required)"
                    name="full_address"
                    inputProps={{
                      maxLength: '3000',
                    }}
                    {...register('full_address', {
                      required: 'Full address is required',
                      validate: {
                        hasMoreThanTwoCommas: (value) => {
                          // Check if the value is the special case
                          if (value === 'secret skip') {
                            return true; // Valid
                          }

                          // Otherwise, check if it has at least two commas
                          const commaCount = (value.match(/,/g) || []).length;
                          return (
                            commaCount >= 2 ||
                            'The address must contain at least two commas (e.g., "Street, City, State")'
                          );
                        },
                      },
                    })}
                    error={!!errors.full_address}
                    helperText={errors.full_address ? errors.full_address.message : ''}
                  />
                </Grid>
                <Grid item xs={12}>
                  <div>Full Address Example:1600 Amphitheatre Parkway, Mountain View, CA, USA</div>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Location (optional)"
                    name="location"
                    inputProps={{
                      maxLength: '100',
                    }}
                    {...register('location', {})}
                  />
                  {errors.location && (
                    <p className="signUpErrorMessage">{errors.location.message}</p>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Street"
                    name="street"
                    inputProps={{
                      maxLength: '100',
                    }}
                    {...register('street', {})}
                  />
                  {errors.street && <p className="signUpErrorMessage">{errors.street.message}</p>}
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="City"
                    name="city"
                    inputProps={{
                      maxLength: '25',
                    }}
                    {...register('city', {})}
                  />
                  {errors.city && <p className="signUpErrorMessage">{errors.city.message}</p>}
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Province/State(Abbr)"
                    name="province"
                    inputProps={{
                      maxLength: '25',
                    }}
                    {...register('province', {})}
                  />
                  {errors.city && <p className="signUpErrorMessage">{errors.city.message}</p>}
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Postal/Zip Code"
                    name="postal_code"
                    inputProps={{
                      maxLength: '25',
                    }}
                    {...register('postal_code', {})}
                  />
                  {errors.postal_code && (
                    <p className="signUpErrorMessage">{errors.postal_code.message}</p>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Country"
                    name="country"
                    inputProps={{
                      maxLength: '25',
                    }}
                    {...register('country', {})}
                  />
                  {errors.country && <p className="signUpErrorMessage">{errors.country.message}</p>}
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Phone Number"
                    name="phone"
                    inputProps={{
                      maxLength: '25',
                    }}
                    {...register('phone', {})}
                  />
                  {errors.phone && <p className="signUpErrorMessage">{errors.phone.message}</p>}
                </Grid>
              </Grid>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                disabled={!loading}
                className={classes.submit}
              >
                Update
              </Button>
            </form>
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
